/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { pureWaveSettingModelSchema } from "../pureWaveSettingModelSchema.ts";
import { z } from "zod";

/**
 * @description Частота
 */
export const getApiPurewaveSetting200Schema = z.lazy(() => pureWaveSettingModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiPurewaveSetting400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiPurewaveSetting401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiPurewaveSetting403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Частота не найдена
 */
export const getApiPurewaveSetting404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiPurewaveSetting500Schema = z.lazy(() => badResponseModelSchema)

export const getApiPurewaveSettingQueryResponseSchema = z.lazy(() => getApiPurewaveSetting200Schema)